export const resizeImg = (url: string, width: number, quality?: number) => {
  if (!(url?.trim())) {
    return '';
  }
  if (url.includes('x-oss-process=image/crop')) {
    return `${url}/resize,w_${width}/quality,Q_${quality || 100}`;
  }
  return `${url.split('?')[0]}?x-oss-process=image/resize,w_${width}/quality,Q_${quality || 100}`;
};
